import React, { useRef, useState } from 'react';
const { default: LetterDrawingComp } = require("./letterDrawingComp");

export const TraceLetterGame = ({ handleClose, onGameComplete }) => {
  const [completed, setCompleted] = useState(false);
  const [score, setScore] = useState(0);

  // Listen for completion from LetterDrawingComp
  const handleLetterComplete = (isCorrect, currentScore, total) => {
    setCompleted(isCorrect);
    setScore(currentScore);
    if (isCorrect && currentScore === total) {
      // All letters completed
      setTimeout(() => {
        onGameComplete?.(3, currentScore * 10); // Example: 3 stars, score
        handleClose?.();
      }, 1200);
    }
  };

  return (
    <LetterDrawingComp type="sequence" onComplete={handleLetterComplete} />
  );
};
